import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import * as arTranslations from '../assets/i18n/ar.json'
@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  selectedLanguage: string = 'en' // Default to English
  private translations: Record<string, string> = {}
  constructor(private translateService: TranslateService) {
    // Retrieve the language from localStorage if available
    const storedLang = localStorage.getItem('siteLang')
    if (storedLang) {
      this.selectedLanguage = storedLang
    }
    this.translations = this.selectedLanguage === 'ar' ? arTranslations : {}

    // Arabic is already bundled, so give it to ngx-translate now (no HTTP fetch, no English flash)
    this.translateService.setTranslation('ar', (arTranslations as any).default ?? arTranslations)
    if (this.selectedLanguage === 'ar') this.translateService.use('ar')
  }

  setLanguage(language: string) {
    this.selectedLanguage = language
    // Store the language in localStorage
    localStorage.setItem('siteLang', language)
    this.translations = language === 'ar' ? arTranslations : {}
  }

  loadTranslations(lang: string): Promise<void> {
    this.translations = lang === 'ar' ? arTranslations : {}
    return Promise.resolve()
  }

  translate(key: string): string {
    return this.translations[key] || key
  }
  getLanguage() {
    return this.selectedLanguage
  }
}
